<template>
  <div class="over">
    <!-- <div class="newtitle">兑换平台</div> -->
    <img class="errorPic" src="/static/images/over.png"  alt="">
    <p style="color: #6A6A6A;font-size: 0.28rem;margin-bottom: 10px;font-weight: bold" v-if="gid!=null">活动还未开始,敬请期待！</p>
    <p style="color: #6A6A6A;font-size: 0.28rem;margin-bottom: 10px;font-weight: bold" v-else>该活动不存在</p>
    <!-- <p style="color: #AEAEAE;font-size: 1.3rem">下次记得早点来哦～</p> -->

  </div>
</template>

<script>
  export default {
    name: "error",
    data () {
      return {
        gid:this.$route.query.gid
      }
    },
    methods: {
      goback:function () {
        history.go(-1)
      },
      gohome:function () {
        this.$router.push({path:'/',query:{gid:this.gid}})
      },
    },
    mounted () {
      $('body').css('background','#fff')
    },
    destroyed: function () {
      $('body').css('background','#EFF3F6')
    },
  }
</script>

<style lang="less" >
  .over{
    .newtitle{
      font-weight: bold;
      width: 100%;
      height: 45px;
      background: #F1F1F1;
      text-align: center;
      font-weight: bold;
      line-height: 45px;
      font-size: 16px;
    }
    .errorPic{
      width: 50%;
      margin-left: 25%;
      margin-top: 40%;
      margin-bottom: 20px;
    }
    p{
      padding: 0px 45px;
      text-align: center;
      margin-top: 3px;
    }
  }
.theme-bg,.van-checkbox--checked,.van-swipe__indicator--active{background-color:red!important;color:#ffffff!important}
.theme-col,.van-icon-checked{color: red!important;}
.col-hover:hover{color: red!important;}
.col-on{color: red!important;}
.col-focus:focus{color: red!important;}
.col-checked:checked:before{
  color: red!important;
}
</style>



// WEBPACK FOOTER //
// src/pages/exchange/over.vue